const onboardRoutes = [
  {
    path: '',
    component: () => import('@/app/shared/layouts/main/Main.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/onboard/user-list',
        name: 'userList',
        component: () => import('./views/user-list/UserList.vue'),
        meta: {
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: 'Onboard' },
                { title: 'Users', active: true },
            ],
            pageTitle: 'Users',
            rule: 'editor'
        },
      },
      {
          path: '/onboard/user-view/:userId',
          name: 'app-user-view',
          component: () => import('./views/UserView.vue'),
          meta: {
              breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Onboard' },
                  { title: 'Users', url: '/onboard/user-list' },
                  { title: 'View', active: true },
              ],
              pageTitle: 'User View',
              rule: 'editor'
          },
      },
      {
          path: '/onboard/user-edit/:userId',
          name: 'app-user-edit',
          component: () => import('./views/user-edit/UserEdit.vue'),
          meta: {
              breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Onboard' },
                  { title: 'Users', url: '/onboard/user-list' },
                  { title: 'Edit', active: true },
              ],
              pageTitle: 'User Edit',
              rule: 'editor'
          },
      },
      {
        path: '/onboard/user-settings',
        name: 'app-user-settings',
        component: () => import('./views/user-settings/UserSettings.vue'),
        meta: {
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: 'Onboard' },
                { title: 'Profile', active: true },
            ],
            pageTitle: 'Profile',
            rule: 'editor'
        },
      },
    ]
  }
];

export default onboardRoutes;
